import { render, staticRenderFns } from "./moneyback-list.vue?vue&type=template&id=bf51c3e2&scoped=true&"
import script from "./moneyback-list.vue?vue&type=script&lang=js&"
export * from "./moneyback-list.vue?vue&type=script&lang=js&"
import style0 from "./moneyback-list.vue?vue&type=style&index=0&id=bf51c3e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf51c3e2",
  null
  
)

export default component.exports